import { render, staticRenderFns } from "./NsLoading.vue?vue&type=template&id=a3678082&"
import script from "./NsLoading.vue?vue&type=script&lang=js&"
export * from "./NsLoading.vue?vue&type=script&lang=js&"
import style0 from "./NsLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports